// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_mech3_desc = /** @type {(inputs: {}) => string} */ () => {
	return `The air cushion stores and returns energy. Less fatigue on long walks. Less strain when standing.`
};

const el_tech_mech3_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Ο θύλακας αέρα αποθηκεύει και επιστρέφει ενέργεια. Λιγότερη κούραση στο μεγάλο περπάτημα. Λιγότερη καταπόνηση στην ορθοστασία.`
};

const ru_tech_mech3_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Воздушная подушка накапливает и возвращает энергию. Меньше усталости при ходьбе. Меньше нагрузки при стоянии.`
};

const he_tech_mech3_desc = /** @type {(inputs: {}) => string} */ () => {
	return `כרית האוויר אוגרת ומחזירה אנרגיה. פחות עייפות בהליכה ארוכה. פחות עומס בעמידה.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_mech3_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_mech3_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_mech3_desc", locale)
	if (locale === "en") return en_tech_mech3_desc(inputs)
	if (locale === "el") return el_tech_mech3_desc(inputs)
	if (locale === "ru") return ru_tech_mech3_desc(inputs)
	if (locale === "he") return he_tech_mech3_desc(inputs)
	return "tech_mech3_desc"
};